import React, { useEffect, useState } from "react";
import IndexComponent from "./Index.component";
import { getCastingSummary } from "api/agency/v2/casting.api";

const IndexContainer = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [castingSummary, setCastingSummary] = useState<any>(null);

    console.log("IndexContainer 렌더링:", { castingSummary, isLoading });

    useEffect(() => {
        const fetchCastingSummary = async () => {
            try {
                console.log("캐스팅 요약 데이터 조회 시작");
                const data = await getCastingSummary();
                console.log("캐스팅 요약 데이터 조회 성공:", data);
                setCastingSummary(data);
                setIsLoading(false);
            } catch (error) {
                console.error("캐스팅 요약 데이터 조회 실패:", error);
                // API 호출 실패 시 더미 데이터 사용
                setCastingSummary({
                    totalRequestCount: 0,
                    waitingChattingCount: 0,
                    canceledChattingCount: 0,
                    deniedChattingCount: 0,
                    onChattingCount: 0,
                    closedChattingCount: 0
                });
                setIsLoading(false);
            }
        };

        fetchCastingSummary();
    }, []);

    return (
        <IndexComponent
            castingSummary={castingSummary}
            isLoading={isLoading}
        />
    );
};

export default IndexContainer;
